// src/api/getHierarchyTree.js
export async function getHierarchyTree(glue_id) {
  const url = `https://4zzfp9ryfe.execute-api.us-east-2.amazonaws.com/dev/hiearchy-graph?glue_id=${encodeURIComponent(glue_id)}`;

  const response = await fetch(url);
  if (!response.ok) throw new Error("Failed to fetch tree data");
  return response.json();
}
